import React, { ReactElement } from 'react';
import { Intro } from '../containers/problem-intro';
import { PageContent } from './page-content';
import { PageType, IntroData, PageDataParams } from 'its-pages';

export class IntroContent extends PageContent {
  public get component(): ReactElement {
    return <Intro introContent={this} key={this.pageData.seed} />;
  }

  public get pageType(): PageType {
    return PageType.Banner;
  }

  public constructor(params: PageDataParams) {
    super(new IntroData(params));
  }
}
